import React from 'react';
import DesktopNav from './DesktopNav';
import MobileNav from './MobileNav';

interface NavigationProps {
  activeSection: string;
  onSectionChange: (section: string) => void;
}

const Navigation: React.FC<NavigationProps> = ({
  activeSection,
  onSectionChange,
}) => {
  return (
    <>
      <DesktopNav
        activeSection={activeSection}
        onSectionChange={onSectionChange}
      />
      <MobileNav
        activeSection={activeSection}
        onSectionChange={onSectionChange}
      />
    </>
  );
};

export default Navigation;
